import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/arrowLeft.svg';

import styles from './ArrowLeftIcon.styles';

type ArrowLeftIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'ArrowLeftIcon' });

export default function ArrowLeftIcon({ className }: ArrowLeftIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
